import { useState, useEffect } from 'react'
import dotloopApi from '../services/dotloopApi'
import { DotloopTemplate } from '../models/DotloopTypes'

export default function useDotloopTemplates(profileId: number | null) {
  const [templates, setTemplates] = useState<DotloopTemplate[]>([])
  const [selectedTemplate, setSelectedTemplate] = useState<DotloopTemplate | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (profileId) {
      fetchTemplates(profileId)
    } else {
      setTemplates([])
      setSelectedTemplate(null)
    }
  }, [profileId])

  const fetchTemplates = async (profId: number) => {
    setLoading(true)
    setError(null)
    
    try {
      console.log(`📄 Fetching templates for profile ${profId}...`)
      const templatesList = await dotloopApi.fetchTemplates(profId)
      
      console.log('📄 Templates from API:', templatesList)
      
      if (templatesList.length === 0) {
        console.log('ℹ️ No templates found for this profile. Templates are optional - you can still create loops without them.')
      }
      
      setTemplates(templatesList)
      
      // Don't auto-select - let user choose or leave empty
      setSelectedTemplate(null)
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch templates'
      setError(errorMessage)
      console.error('❌ Error fetching templates:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleTemplateChange = (templateId: number | null) => {
    if (templateId === null) {
      setSelectedTemplate(null)
      return
    }
    const template = templates.find(t => t.id === templateId)
    setSelectedTemplate(template || null)
  }

  const clearTemplate = () => {
    setSelectedTemplate(null)
  }

  const refreshTemplates = () => {
    if (profileId) {
      fetchTemplates(profileId)
    }
  }

  return {
    templates,
    selectedTemplate,
    loading,
    error,
    handleTemplateChange,
    clearTemplate,
    refreshTemplates,
  }
}

